import { takeEvery, put, call } from 'redux-saga/effects';
import { searchNews } from '../../../services/news/news-service';
import {
    receiveNewsData,
    SEARCH_NEWS_REQUEST_DATA,
    newsRequestFailed
} from '../actions/search-news-actions';

function* fetchNews(action) {
    try {
        const response = yield call(searchNews, action.payload.params);
        yield put(receiveNewsData(response));
    } catch (error) {
        yield put(newsRequestFailed(error));
    }
}

export function* watchSearchForNews() {
    yield takeEvery(SEARCH_NEWS_REQUEST_DATA, fetchNews);
}
